import React from 'react';
import { useDesign } from '../contexts/DesignContext';
import StaticPageLayout from '../components/Layout/StaticPageLayout';

const Contact = () => {
  const { designConfig } = useDesign();

  const email = designConfig.contact_email || '[TODO: add support email in Admin Settings]';
  const phone = designConfig.contact_phone || '[TODO: add support phone in Admin Settings]';

  const addressParts = [
    designConfig.invoice_company_address,
    designConfig.invoice_company_city,
    designConfig.invoice_company_state,
    designConfig.invoice_company_zip,
    designConfig.invoice_company_country
  ].filter(Boolean);
  const address = addressParts.length > 0
    ? addressParts.join(', ')
    : '[TODO: add business address in Admin Settings]';

  // wa.me requires digits only (no +, spaces, or dashes) in the number.
  const whatsappDigits = (designConfig.whatsapp_number || '').replace(/[^\d]/g, '');
  const whatsappMessage = designConfig.whatsapp_message || 'Hi Viverra, I have a question about a product.';
  const whatsappUrl = whatsappDigits
    ? `https://wa.me/${whatsappDigits}?text=${encodeURIComponent(whatsappMessage)}`
    : null;

  return (
    <StaticPageLayout title="Contact Us">
      <p>
        We'd love to hear from you. Reach out with questions about an order, a product, or anything else -
        we usually respond within 24-48 hours.
      </p>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Email</h2>
        <p>{email}</p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Phone</h2>
        <p>{phone}</p>
      </div>

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Address</h2>
        <p>{address}</p>
      </div>

      {whatsappUrl && (
        <div>
          <h2 className="text-lg font-semibold text-gray-900 mb-2">Chat With Us</h2>
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-white font-medium transition-colors"
            style={{ backgroundColor: '#25D366' }}
          >
            <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor" aria-hidden="true">
              <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.87 9.87 0 004.74 1.21h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2zm0 18.15h-.01a8.2 8.2 0 01-4.18-1.14l-.3-.18-3.12.82.83-3.04-.2-.31a8.22 8.22 0 01-1.26-4.39c0-4.54 3.7-8.24 8.25-8.24 2.2 0 4.27.86 5.83 2.42a8.18 8.18 0 012.41 5.83c0 4.55-3.7 8.24-8.25 8.24zm4.52-6.17c-.25-.12-1.47-.72-1.7-.81-.23-.08-.39-.12-.56.13-.17.24-.64.8-.78.97-.14.16-.29.18-.53.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.24-1.47-1.39-1.72-.14-.24-.02-.38.11-.5.11-.11.25-.29.37-.43.12-.14.16-.24.25-.4.08-.16.04-.31-.02-.43-.06-.12-.56-1.35-.77-1.85-.2-.48-.41-.42-.56-.42h-.48c-.16 0-.43.06-.66.31-.23.24-.86.85-.86 2.06s.89 2.39 1.01 2.56c.12.16 1.75 2.67 4.24 3.74.59.26 1.06.41 1.42.52.6.19 1.14.16 1.57.1.48-.07 1.47-.6 1.68-1.18.21-.58.21-1.08.15-1.18-.06-.1-.23-.16-.48-.28z"/>
            </svg>
            Chat with us on WhatsApp
          </a>
        </div>
      )}

      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Instagram</h2>
        <p>
          <a
            href="https://www.instagram.com/viverrafancy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            @viverrafancy
          </a>
        </p>
      </div>
    </StaticPageLayout>
  );
};

export default Contact;
